import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
  FieldArray,
} from 'redux-form';
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  ButtonToolbar,
  Badge,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import TextBox from '../../../../shared/components/form/TextBox';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import ObjetivosMateriaTable from './ObjetivosMateriaTable';
import CronogramaClasesTable from './CronogramaClasesTable';
import PracticaLaboratorioTable from './PracticaLaboratorioTable';
import ProyectoTrabajoPracticoTable from './ProyectoTrabajoPracticoTable';
import ActividadComplementariaTable from './ActividadComplementariaTable';
import HorariosTable from './HorariosTable';

import Confirm from '../../../../shared/components/Confirm';

import validate from '../validate';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import { dateTimeFormat } from '../../../../helpers/dateFormat';

class PlaneamientoForm extends PureComponent {
  static propTypes = {
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.any,
    }),
    page: PropTypes.number.isRequired,
    changed: PropTypes.bool.isRequired,
    setPage: PropTypes.func.isRequired,
    previousPage: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCopyLastPlanning: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,

    onAddItemArray: PropTypes.func.isRequired,
    onDeleteItemArray: PropTypes.func.isRequired,
    onChangeText: PropTypes.func.isRequired,
    onChangeSelect: PropTypes.func.isRequired,

    submitting: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    loadingPage: PropTypes.bool.isRequired,
    createPlanning: PropTypes.bool.isRequired,
    canEditarPlaneamiento: PropTypes.bool.isRequired,
    finEditarPlaneamiento: PropTypes.string.isRequired,
    codigoClassroom: PropTypes.string,

    horasLaboratorioSemanal: PropTypes.number.isRequired,
    horasPracticaSemanal: PropTypes.number.isRequired,
    horasTeoriaSemanal: PropTypes.number.isRequired,
    totalHorasSemanal: PropTypes.number.isRequired,

    filters: PropTypes.shape({}),
    materiaPeriodo: PropTypes.shape({}).isRequired,
    oldPlannings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    objetivosMaterias: PropTypes.arrayOf(PropTypes.shape({})),
    cronogramaClases: PropTypes.arrayOf(PropTypes.shape({})),
    practicasLaboratorios: PropTypes.arrayOf(PropTypes.shape({})),
    proyectosTrabajosPracticos: PropTypes.arrayOf(PropTypes.shape({})),
    actividadesComplementarias: PropTypes.arrayOf(PropTypes.shape({})),
    preRequisitos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    horarios: PropTypes.arrayOf(PropTypes.shape({})),
    profesores: PropTypes.arrayOf(PropTypes.shape({})),
    duracionActividad: PropTypes.arrayOf(PropTypes.shape({})),
  }

  static defaultProps = {
    submitting: false,
    meta: {},
    filters: {},
    objetivosMaterias: [],
    cronogramaClases: [],
    practicasLaboratorios: [],
    proyectosTrabajosPracticos: [],
    actividadesComplementarias: [],
    duracionActividad: [],

    codigoClassroom: '',
    horarios: [],
    profesores: [],
  }

  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
    };

    this.stepTitles = [
      { step: 1, title: <>Identificaci&oacute;n</> },
      { step: 2, title: <>Fundamentaci&#243;n / Contribuci&#243;n</> },
      { step: 3, title: <>Objetivos</> },
      { step: 4, title: <><span>Valores</span> / <span>Metodolog&iacute;a</span> / <span>Estrategias</span></> },
      { step: 5, title: <>Cronograma de clases</> },
      { step: 6, title: <>Cuadro de pr&#225;cticas de laboratorios</> },
      { step: 7, title: <>Proyectos o/y trabajos pr&#225;cticos</> },
      { step: 8, title: <>Actividades complementarias</> },
      { step: 9, title: <><span>Bibliograf&iacute;a b&#225;sica</span> / <span>complementaria</span></> },
    ];
  }

  toggle = () => {
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  wizardContentToolbar = ({
    label, previousPage, nextPage, submitting, addBtn,
  }) => (
    <div className="wizard__content-toolbar">
      {this.buttonToolbar({ previousPage, nextPage, submitting })}
      <h4 className="wizard__title">
        <span className="form__form-group-label">
          {label}
        </span>
      </h4>
      {addBtn}
    </div>
  );

  buttonToolbar = ({ previousPage, nextPage, submitting }) => {
    if (nextPage) {
      return (
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" type="button" onClick={previousPage} className="previous">Anterior</Button>
          <Button color="primary" type="submit" onClick={nextPage} disabled={submitting} className="next">
            Siguiente
          </Button>
        </ButtonToolbar>
      );
    }

    return (
      <ButtonToolbar className="form__button-toolbar wizard__toolbar">
        <Button color="primary" type="button" onClick={previousPage} className="previous">Anterior</Button>
        <Button color="primary" type="submit" disabled={submitting} className="next">Siguiente</Button>
      </ButtonToolbar>
    );
  };

  setPage = (step) => {
    const {
      changed, page, setPage, onSubmit,
    } = this.props;

    if (page === step) {
      return;
    }

    if (changed) {
      Confirm({
        title: 'Hay cambios sin guardar',
        question: (<>&iquest;Deseas guardar los cambios antes de continuar?.</>),
        yesLabel: 'Si, guardar',
        noLabel: 'No, continuar',
        onConfirm: () => {
          onSubmit(this.props);
        },
        onCancel: () => {
          setPage(step);
        },
      });

      return;
    }

    setPage(step);
  };

  step = ({ step, title }) => {
    const { page } = this.props;
    return (
      <button
        key={`step-${step}`}
        type="button"
        onClick={() => this.setPage(step)}
        className={
          `wizard__step${page === step ? ' wizard__step--active' : ''}`
        }
      >
        <p>{title}</p>
      </button>
    );
  };

  createPlanning = () => {
    const {
      createPlanning,
      canEditarPlaneamiento,
      finEditarPlaneamiento,
      handleSubmit,
      onSubmit,
      onCopyLastPlanning,
      oldPlannings,
    } = this.props;

    const {
      dropdownOpen,
    } = this.state;

    // if (loadingPage) {
    //   return <LoadingSpinner />;
    // }

    return (
      <Row>
        <Col>
          <h4 style={{ marginBottom: '0.5rem' }}>
            <Badge color={canEditarPlaneamiento ? 'primary' : 'warning'}>
              <>Fecha L&iacute;mite cargar planeamiento</>
            </Badge>
            {' '}
            <Badge color={canEditarPlaneamiento ? 'primary' : 'warning'}>
              <>{finEditarPlaneamiento && dateTimeFormat(finEditarPlaneamiento)}</>
            </Badge>
          </h4>
        </Col>
        {
          createPlanning && canEditarPlaneamiento ? (
            <Col>
              <Form onSubmit={handleSubmit}>
                <div className="card__title">
                  <Dropdown isOpen={dropdownOpen} toggle={this.toggle} direction="down">
                    <DropdownToggle
                      size="sm"
                      className="btn action"
                      block="true"
                      color="primary"
                      style={{ width: 'auto' }}
                    >
                      <i className="fa fa-check-square-o" aria-hidden="true" /> Crear Planeamiento
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem
                        className="btn-primary"
                        onClick={() => onSubmit({
                          ...this.props,
                          oldMateriaPeriodo: null,
                          isNew: true,
                        })}
                      >
                        <i className="fa fa-plus" aria-hidden="true" /> Crear Nuevo Planeamiento
                      </DropdownItem>
                      {oldPlannings.map(old => (
                        <DropdownItem
                          key={old.id}
                          onClick={() => onCopyLastPlanning({
                            ...this.props,
                            oldMateriaPeriodoId: old.id,
                            isNew: true,
                          })}
                        >
                          <i className="fa fa-clone" aria-hidden="true" /> Copiar Planeamiento {old.anho}/{old.seccion}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </Form>
            </Col>
          ) : null
        }
      </Row>
    );
  };

  showPlanning = ({
    page, createPlanning, listProfesores, loadingPage,
  }) => {
    if (createPlanning) {
      return null;
    }

    return (
      <Row>
        <Col sm={12} md={12} lg={3}>
          <div className="wizard__steps">
            {this.stepTitles.map(st => this.step(st))}
          </div>
        </Col>
        <Col sm={12} md={12} lg={9}>
          {
            loadingPage
              ? <LoadingSpinner />
              : (
                <div className="wizard__form-wrapper">
                  {this.page1(page)}
                  {this.page2(page)}
                  {this.page3(page)}
                  {this.page4(page)}

                  {this.page5(page, listProfesores)}
                  {this.page6(page, listProfesores)}
                  {this.page7(page, listProfesores)}

                  {this.page8(page)}
                  {this.page9(page)}
                </div>
              )
          }
        </Col>
      </Row>
    );
  };

  addButton = (stepName) => {
    const { materiaPeriodo, onAddItemArray } = this.props;

    if (!materiaPeriodo.canEditarPlaneamiento) {
      return null;
    }

    return (
      <Button
        size="sm"
        color="primary"
        style={{
          marginBottom: '1rem',
          position: 'sticky',
          top: '144px',
          zIndex: '1',
        }}
        onClick={() => onAddItemArray({ name: stepName })}
        className="font-weight-bold"
      >
        <i className="fa fa-plus" />
        {' '}
        Agregar
      </Button>
    );
  };

  page1 = (page) => {
    if (page !== 1) {
      return null;
    }

    const {
      materiaPeriodo,
      codigoClassroom,
      horarios = [],
      profesores = [],
      handleSubmit,
      previousPage,
      submitting,
      loadingPage,
      onChangeText,
      horasLaboratorioSemanal,
      horasPracticaSemanal,
      horasTeoriaSemanal,
      totalHorasSemanal,
      preRequisitos = [],
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 1).map(st => st.title)[0],
          previousPage,
          submitting,
        })}
        <div className="form__form-group">
          <div className="form__form-group-field">
            <HorariosTable
              key="horariosTable"
              name="horariosTable"
              codigoClassroom={codigoClassroom}
              materiaPeriodo={{
                ...materiaPeriodo,
                horasLaboratorioSemanal,
                horasPracticaSemanal,
                horasTeoriaSemanal,
                totalHorasSemanal,
                preRequisitos,
              }}
              profesores={profesores}
              items={horarios}
              onChangeText={onChangeText}
            />
          </div>
        </div>
      </Form>
    );
  };

  page2 = (page) => {
    if (page !== 2) {
      return null;
    }

    const {
      onChangeText,
      submitting,
      handleSubmit,
      previousPage,
      loadingPage,
      materiaPeriodo,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 2).map(st => st.title)[0],
          previousPage,
          submitting,
        })}
        <div className="two-col">
          <div>
            <h5 className="wizard__title">
              <span className="form__form-group-label required">
                II- Fundamentaci&#243;n de la materia :
              </span>
            </h5>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="fundamentacionMateria"
                  component={TextBox}
                  multiple
                  style={{ minHeight: '26vh' }}
                  type="textarea"
                  disabled={!materiaPeriodo.canEditarPlaneamiento}
                  readOnly={!materiaPeriodo.canEditarPlaneamiento}
                  maxLength={4096}
                  placeholder="Fundamentaci&#243;n de la materia"
                  autoComplete="false"
                  onChange={v => onChangeText(v)}
                />
              </div>
            </div>
          </div>
          <div>
            <h5 className="wizard__title">
              <span className="form__form-group-label required">
                III- Contribuci&#243;n de la materia a la carrera :
              </span>
            </h5>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="contribucionMateria"
                  component={TextBox}
                  multiple
                  type="textarea"
                  style={{ minHeight: '26vh' }}
                  disabled={!materiaPeriodo.canEditarPlaneamiento}
                  readOnly={!materiaPeriodo.canEditarPlaneamiento}
                  maxLength={4096}
                  placeholder="Contribuci&#243;n de la materia a la carrera"
                  autoComplete="false"
                  onChange={v => onChangeText(v)}
                />
              </div>
            </div>
          </div>
        </div>
      </Form>
    );
  };

  page3 = (page) => {
    if (page !== 3) {
      return null;
    }

    const {
      onChangeText,
      onAddItemArray,
      onDeleteItemArray,
      materiaPeriodo,
      objetivosMaterias,
      handleSubmit,
      previousPage,
      submitting,
      loadingPage,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: <>IV. Objetivos de la materia</>,
          previousPage,
          submitting,
          addBtn: this.addButton('objetivosMaterias'),
        })}
        <div className="form__form-group">
          <FieldArray
            key="objetivosMaterias"
            name="objetivosMaterias"
            component={ObjetivosMateriaTable}
            materiaPeriodo={materiaPeriodo}
            items={objetivosMaterias}
            onAddItemArray={onAddItemArray}
            onDeleteItemArray={onDeleteItemArray}
            onChangeText={onChangeText}
          />
        </div>
      </Form>
    );
  };

  page4 = (page) => {
    if (page !== 4) {
      return null;
    }

    const {
      onChangeText,
      loadingPage,
      handleSubmit,
      previousPage,
      submitting,
      materiaPeriodo,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }
    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 4).map(st => st.title)[0],
          previousPage,
          submitting,
        })}
        <div className="two-col">
          <div>
            <h5 className="wizard__title">
              <span className="form__form-group-label required">
                V - Valores contemplados
              </span>
            </h5>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="valoresContemplados"
                  component={TextBox}
                  multiple
                  type="textarea"
                  style={{ minHeight: '26vh' }}
                  disabled={!materiaPeriodo.canEditarPlaneamiento}
                  readOnly={!materiaPeriodo.canEditarPlaneamiento}
                  maxLength={4096}
                  placeholder="Valores contemplados"
                  autoComplete="false"
                  onChange={v => onChangeText(v)}
                />
              </div>
            </div>
          </div>
          <div>
            <h5 className="wizard__title">
              <span className="form__form-group-label required">
                VI - Metodolog&iacute;a de la ense&ntilde;anza
              </span>
            </h5>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="metodologiaEnsenhanza"
                  component={TextBox}
                  multiple
                  type="textarea"
                  style={{ minHeight: '26vh' }}
                  disabled={!materiaPeriodo.canEditarPlaneamiento}
                  readOnly={!materiaPeriodo.canEditarPlaneamiento}
                  maxLength={4096}
                  placeholder="Metodolog&iacute;a de la ense&ntilde;anza"
                  autoComplete="false"
                  onChange={v => onChangeText(v)}
                />
              </div>
            </div>
          </div>
          <div>
            <h5 className="wizard__title">
              <span className="form__form-group-label required">
                VII - Estrategias de evauaci&#243;n
              </span>
            </h5>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="estrategiasEvauacion"
                  component={TextBox}
                  multiple
                  type="textarea"
                  style={{ minHeight: '26vh' }}
                  disabled={!materiaPeriodo.canEditarPlaneamiento}
                  readOnly={!materiaPeriodo.canEditarPlaneamiento}
                  maxLength={4096}
                  placeholder="Estrategias de evauaci&#243;n"
                  autoComplete="false"
                  onChange={v => onChangeText(v)}
                />
              </div>
            </div>
          </div>
        </div>
      </Form>
    );
  };

  page5 = (page, listProfesores) => {
    if (page !== 5) {
      return null;
    }

    const {
      onChangeText,
      onChangeSelect,
      onDeleteItemArray,
      materiaPeriodo,
      cronogramaClases = [],
      loadingPage,
      handleSubmit,
      previousPage,
      submitting,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 5).map(st => st.title)[0],
          previousPage,
          submitting,
          addBtn: this.addButton('cronogramaClases'),
        })}
        <div className="form__form-group">
          <FieldArray
            key="cronogramaClases"
            name="cronogramaClases"
            component={CronogramaClasesTable}
            items={cronogramaClases}
            materiaPeriodo={materiaPeriodo}
            profesores={listProfesores}
            onDeleteItemArray={onDeleteItemArray}
            onChangeText={onChangeText}
            onChangeSelect={onChangeSelect}
          />
        </div>
      </Form>
    );
  };

  page6 = (page, listProfesores) => {
    if (page !== 6) {
      return null;
    }

    const {
      onChangeText,
      onChangeSelect,
      onDeleteItemArray,
      materiaPeriodo,

      practicasLaboratorios = [],
      duracionActividad = [],
      loadingPage,
      previousPage,
      submitting,
      handleSubmit,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 6).map(st => st.title)[0],
          previousPage,
          submitting,
          addBtn: this.addButton('practicasLaboratorios'),
        })}
        <div className="form__form-group">
          <FieldArray
            key="practicasLaboratorios"
            name="practicasLaboratorios"
            component={PracticaLaboratorioTable}
            items={practicasLaboratorios}
            materiaPeriodo={materiaPeriodo}
            duracionActividad={duracionActividad}
            profesores={listProfesores}
            onDeleteItemArray={onDeleteItemArray}
            onChangeText={onChangeText}
            onChangeSelect={onChangeSelect}
          />
        </div>
      </Form>
    );
  };

  page7 = (page, listProfesores) => {
    if (page !== 7) {
      return null;
    }

    const {
      onChangeText,
      onChangeSelect,
      onDeleteItemArray,
      materiaPeriodo,

      proyectosTrabajosPracticos = [],
      duracionActividad = [],
      loadingPage,
      previousPage,
      submitting,
      handleSubmit,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 7).map(st => st.title)[0],
          previousPage,
          submitting,
          addBtn: this.addButton('proyectosTrabajosPracticos'),
        })}
        <div className="form__form-group">
          <FieldArray
            key="proyectosTrabajosPracticos"
            name="proyectosTrabajosPracticos"
            component={ProyectoTrabajoPracticoTable}
            items={proyectosTrabajosPracticos}
            materiaPeriodo={materiaPeriodo}
            duracionActividad={duracionActividad}
            profesores={listProfesores}
            onDeleteItemArray={onDeleteItemArray}
            onChangeText={onChangeText}
            onChangeSelect={onChangeSelect}
          />
        </div>
      </Form>
    );
  };

  page8 = (page) => {
    if (page !== 8) {
      return null;
    }

    const {
      onChangeText,
      onChangeSelect,
      onDeleteItemArray,
      materiaPeriodo,

      actividadesComplementarias = [],
      loadingPage,
      previousPage,
      submitting,
      handleSubmit,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 8).map(st => st.title)[0],
          previousPage,
          submitting,
          addBtn: this.addButton('actividadesComplementarias'),
        })}
        <div className="form__form-group">
          <FieldArray
            key="actividadesComplementarias"
            name="actividadesComplementarias"
            component={ActividadComplementariaTable}
            items={actividadesComplementarias}
            materiaPeriodo={materiaPeriodo}
            onDeleteItemArray={onDeleteItemArray}
            onChangeText={onChangeText}
            onChangeSelect={onChangeSelect}
          />
        </div>
      </Form>
    );
  };

  page9 = (page) => {
    if (page !== 9) {
      return null;
    }

    const {
      onChangeText,
      loadingPage,
      previousPage,
      submitting,
      handleSubmit,
      materiaPeriodo,
    } = this.props;

    if (loadingPage) {
      return <LoadingSpinner />;
    }

    return (
      <Form className="form wizard__form" onSubmit={handleSubmit}>
        {this.wizardContentToolbar({
          label: this.stepTitles.filter(st => st.step === 9).map(st => st.title)[0],
          previousPage,
          submitting,
        })}
        <div className="two-col">
          <div>
            <h5 className="wizard__title">
              <span className="form__form-group-label required">
                XII - Bibliograf&iacute;a b&#225;sica
              </span>
            </h5>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  key="bibliografiaBasica"
                  name="bibliografiaBasica"
                  component={TextBox}
                  multiple
                  type="textarea"
                  style={{ minHeight: '38vh' }}
                  disabled={!materiaPeriodo.canEditarPlaneamiento}
                  readOnly={!materiaPeriodo.canEditarPlaneamiento}
                  maxLength={4096}
                  placeholder="Bibliografia b&#225;sica"
                  autoComplete="false"
                  onChange={v => onChangeText(v)}
                />
              </div>
            </div>
          </div>
          <div>
            <h5 className="wizard__title">
              <span className="form__form-group-label">
                XIII - Bibliograf&iacute;a complementaria
              </span>
            </h5>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="bibliografiaComplementaria"
                  component={TextBox}
                  multiple
                  type="textarea"
                  style={{ minHeight: '38vh' }}
                  disabled={!materiaPeriodo.canEditarPlaneamiento}
                  readOnly={!materiaPeriodo.canEditarPlaneamiento}
                  maxLength={4096}
                  placeholder="Bibliograf&iacute;a complementaria"
                  autoComplete="false"
                  onChange={v => onChangeText(v)}
                />
              </div>
            </div>
          </div>
        </div>
      </Form>
    );
  };

  render() {
    const {
      loading,
      loadingPage,
      horarios = [],
      profesores = [],
      page,
      createPlanning,
      onDownload,
    } = this.props;

    if (loading || horarios.length === -1) {
      return <LoadingSpinner />;
    }

    const listProfesores = profesores.map(({ id, profesor }) => ({
      value: id,
      label: profesor,
    }));

    return (
      <Col md={12} lg={12}>
        <Card className="card-x">
          <div style={{ display: 'flex', columnGap: '1rem', marginBottom: '0' }}>
            <h3 className="page-title">
              Datos del planeamiento
            </h3>
            {
              !createPlanning ? (
                <button
                  className="btn btn-link btn-sm"
                  type="button"
                  onClick={onDownload}
                >
                  <span className="fa fa-cloud-download">&nbsp;</span>
                  Descargar planeamiento
                </button>
              ) : null
            }
          </div>
          <CardBody className="wizard">
            {this.createPlanning()}
            {this.showPlanning({
              page, createPlanning, listProfesores, loadingPage,
            })}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxPlaneamientoForm = reduxForm({
  form: 'PlaneamientoForm',
  validate,
  enableReinitialize: true,
})(PlaneamientoForm);

export default setPropsAsInitialValues(ReduxPlaneamientoForm);
